<template>
  <div id="TransmisionEnVivo_div" class="w-100 px-5 py-0">
    <div id="TituloTransmisionEnVivo_div">
      <h1 style="margin-bottom: 0px;">TRANSMISIÓN EN VIVO</h1>
      <h3 style="margin-top: 0px;">Audiencias en transmisión</h3>
    </div>
    <div class="row d-flex">
      <div id="BusquedaTransmisionEnVivo_div" class="col-12 col-sm-12 col-md-12 col-lg-3 padding-div-low">
        <div class="area">
          <FiltrosDeBusqueda :catalogos="catalogos" :ejecutaLaFuncion="cargaAudienciasEnTransmision"></FiltrosDeBusqueda>
        </div>
      </div>
      <div id="ContenidoTransmisionEnVivo_div" class="col-12 col-sm-12 col-md-12 col-lg-9 padding-div-low">
        <div class="area">
          <h4>Transmisiones en curso</h4>
          <h6 v-if="transmisionesEnVivo.length>0">Seleccione una transmisión para verla</h6>
          <hr />
          <div class="table-responsive">
            <table class="table table-striped table-light table-hover">
              <thead class="thead-dark">
                <tr>
                  <th class="text-center">Hora</th>
                  <th class="text-center">Partido Judicial</th>
                  <th class="text-center">Tipo de Documento</th>
                  <th class="text-center">Documento</th>
                  <th class="text-center">Juez</th>
                  <th class="text-center">Tipo de Audiencia</th>
                  <th class="text-center">Sala</th>
                  <th class="text-center">Operador</th>
                  <th class="text-center">Estatus</th>
                  <th></th>
                </tr>
              </thead>
              <tbody class="text-dark">
                <tr v-for="transmisionEnVivo in transmisionesEnVivo">
                  <td v-html="obtenFechaDeAudienciaConFormato(transmisionEnVivo.FechaAudiencia)" style="width: 100px;"></td>
                  <td class="text-center">
                    {{transmisionEnVivo.PartidoJudicial.Nombre}}
                  </td>
                  <td class="text-center">
                    {{transmisionEnVivo.TipoDocumento.Nombre}}
                  </td>
                  <td class="text-center">
                    {{transmisionEnVivo.Consecutivo}}
                  </td>
                  <td class="text-center" v-if="transmisionEnVivo.JuecesEnAudiencia.length === 0">SIN JUEZ</td>
                  <td class="text-center" v-if="transmisionEnVivo.JuecesEnAudiencia.length > 0"><p v-for="juez in transmisionEnVivo.JuecesEnAudiencia">{{juez.Juez.Nombre}} {{juez.Juez.ApellidoPaterno}} {{juez.Juez.ApellidoMaterno}}</p></td>
                  <td class="text-center">
                    {{transmisionEnVivo.TipoAudiencia.Nombre}}
                  </td>
                  <td class="text-center">
                    {{transmisionEnVivo.Sala.Nombre}}
                  </td>
                  <td class="text-center">
                    {{transmisionEnVivo.Usuario_OperadorDeSala.Nombre}}
                  </td>
                  <td class="text-center">
                    {{transmisionEnVivo.TipoEstatusDeAudiencia.Nombre}}
                  </td>
                  <td class="text-center">
                  <router-link :to="{name: 'TransmisionEnVivo_Reproductor', params: { AudienciaId: transmisionEnVivo.AudienciaId } }"><i class="fas fa-video" title="Ver transmisión"></i></router-link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  //Importaciones estandarizadas
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import sistemas from '@/../static/js/sistemas'
  import api from '@/../static/js/api'
  import axios from 'axios'

  export default {
    components: {
      FiltrosDeBusqueda: sistemas.Forseti.FiltrosDeBusqueda
    },
    data() {
      return {
        enumeraciones,
        catalogos: [
          { catalogoId: enumeraciones.catalogos.PartidosJudiciales, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione },
          { catalogoId: enumeraciones.catalogos.Materias, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione },
          { catalogoId: enumeraciones.catalogos.Juzgados, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione },
          //{ catalogoId: enumeraciones.catalogos.Consecutivo }, //verificar si es necesario
          { catalogoId: enumeraciones.catalogos.Salas, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione },
          //{ catalogoId: enumeraciones.catalogos.TiposDeDocumentos, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione }, verificar si es necesario
        ],
        transmisionesEnVivo: []
      }
    },
    mounted() {
      //this.cargaAudienciasEnTransmision();
    },
    methods: {
      obtenFechaDeAudienciaConFormato: function (fechaDeAudiencia) {
        return moment(fechaDeAudiencia).format("DD-MM-YYYY <br /> h:mm a")
      },
      cargaAudienciasEnTransmision: function () {
        if(this.validaParametros())
        {
          comun.SeEstaCargandoInformacion(true);
          const parametros = {
            PartidoJudicialId: this.$store.state.PJ_Catalogos_009PartidosJudiciales['filtroDeBusqueda_PartidoJudicial'],
            MateriaId: this.$store.state.PJ_Catalogos_002Materias['filtroDeBusqueda_Materia'],
            AreaId: this.$store.state.PJ_Catalogos_001Areas['filtroDeBusqueda_Area'],
            SalaId: this.$store.state.PJ_Catalogos_020Salas['filtroDeBusqueda_Sala'],
            JuezId: this.$store.state.PJ_Catalogos_009PartidoJudicialId,
            EsPrueba: this.enumeraciones.EsPrueba
          }

          axios.post(
            api.conexion + api.Forseti.sistema.transmision.transmisionEnVivo.GetAudienciasDeTransmision,
            parametros,
            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
          ).then(respuesta => {
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
              this.transmisionesEnVivo = [];
            } else { 
              this.transmisionesEnVivo = respuesta.data.AudienciasEnTransmision;
              if(this.transmisionesEnVivo.length==0)
              {
                comun.mensajeDeAlerta("No hay transmisiones en proceso para esta Sala.", null, null);
              }            
            }
            comun.SeEstaCargandoInformacion(false);
          }
          ).catch(excepcion => {
          console.log(excepcion);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
          comun.SeEstaCargandoInformacion(false);
          this.audienciasPendientes = [];
        });
        }
      },
      validaParametros(){
        if(this.$store.state.PJ_Catalogos_009PartidosJudiciales['filtroDeBusqueda_PartidoJudicial'] == -1)
        {
          comun.mensajeDeAlerta("Seleccione un Partido Judicial.", null, null);
          return false
        };
        if(this.$store.state.PJ_Catalogos_002Materias['filtroDeBusqueda_Materia'] == -1)
        {
          comun.mensajeDeAlerta("Seleccione una Materia.", null, null);
          return false
        };
        if(this.$store.state.PJ_Catalogos_001Areas['filtroDeBusqueda_Area'] == -1)
        {
          comun.mensajeDeAlerta("Seleccione un Juzgado.", null, null);
          return false
        };
        if(this.$store.state.PJ_Catalogos_020Salas['filtroDeBusqueda_Sala'] == -1)
        {
          comun.mensajeDeAlerta("Seleccione una Sala.", null, null);
          return false
        };

        return true;
      }
    }
  }
</script>

<style scoped>
  .padding-div-low {
    padding-top: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Forseti/Transmision/TransmisionEnVivo/TransmisionEnVivo.vue